require.ensure([], function() {
    require('../router/vromo.tsx');
});
